.button {
  display: flex;
  align-items: center;
  min-height: 44px;
  padding: 0 12px;
  border: 0;
  background: none;
  font-size: 15px;
  font-weight: 700;
  color: var(--ink-2);
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
}

.button:disabled {
  color: var(--line);
  cursor: default;
}

/* The message hangs under the button, so showing it never moves the rest of
 * Profile & settings. */
.signOut {
  position: relative;
  display: flex;
}

.error {
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 1;
  width: max-content;
  max-width: 280px;
  padding: 8px 10px;
  border: var(--outline);
  border-radius: var(--radius-control);
  background: var(--error-soft);
  font-size: 14px;
  font-weight: 600;
  color: var(--ink);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}

.discard {
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  font-weight: 700;
  color: var(--ink);
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
}

.discard:disabled {
  color: var(--ink-2);
  cursor: default;
}
